import React, { useState, useRef, useEffect } from 'react';
import { Info } from 'lucide-react';

/**
 * Tooltip explicatif pour les KPIs.
 * Affiche un point d'interrogation cliquable avec une bulle d'explication.
 * @param {string} text - Texte explicatif du KPI
 */
export default function KpiTooltip({ text }) {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        if (!open) return;
        const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
        document.addEventListener('mousedown', close);
        return () => document.removeEventListener('mousedown', close);
    }, [open]);

    return (
        <span className="relative inline-flex" ref={ref}>
            <button
                onClick={(e) => { e.stopPropagation(); setOpen(!open); }}
                className="ml-1 text-muted-foreground/50 hover:text-[#FF914D] transition-colors"
                aria-label="Explication"
                data-testid="kpi-tooltip-trigger"
            >
                <Info className="w-3 h-3" />
            </button>
            {open && (
                <span className="block absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-56 sm:w-64 p-3 bg-slate-800 border border-white/10 rounded-xl shadow-2xl z-50 text-left animate-in fade-in zoom-in-95 duration-150">
                    <span className="block text-[11px] leading-relaxed text-white/80">{text}</span>
                    <span className="block absolute top-full left-1/2 -translate-x-1/2 w-2 h-2 bg-slate-800 border-r border-b border-white/10 rotate-45 -mt-1" />
                </span>
            )}
        </span>
    );
}
